import Box from '@mui/material/Box';
import { Trans } from "react-i18next";
import ChevronRight from '@mui/icons-material/ChevronRight';
import IndicatorsContext from './IndicatorsContext';
import moment from 'moment';
import { useParams, useNavigate, NavigateFunction } from "react-router-dom";
import Button from "@mui/material/Button";
export default function () {
  const navigate = useNavigate();
  function viewUnit(numberPlate: string){
    navigate(`/web/unit/${numberPlate}`);
  }
  return (
    <IndicatorsContext.Consumer>
      { context => {
        return (
          <Box className="indicators-pending-card">
            <Box className="indicators-pending-card-title">
              <Box className="indicators-subtitle"><Trans i18nKey={`screens.indicators.pendingDeliveriesTitle`}></Trans></Box>
              <Box className="indicators-big-count">{context.indicators.pendingDeliveries.length}</Box>
            </Box>
            <Box>
              {context.indicators.pendingDeliveries.map((pendingDelivery: any, index: number) => (
                <Box className="indicators-pending-card-item" key={index} >
                  <Box className="indicators-item-bold" sx={{flexGrow: 1}}>
                    {`${pendingDelivery.numberPlate} ${pendingDelivery.dateTime ? moment( pendingDelivery.dateTime).format('DD/MM/YYYY HH:mm'): ''}`}
                  </Box>
                  <Button size="small" onClick={()=>viewUnit(pendingDelivery.numberPlate)}><ChevronRight/></Button>
                </Box>
              ))}
            </Box>
          </Box>
        )
      }}
    </IndicatorsContext.Consumer>
  );
}
